<script>
import service from '@/services/endosso';
import ModalVeiculoSemFipeEndosso from '@/views/modais/ModalVeiculoSemFipeEndosso.vue';
export default {
  components: { ModalVeiculoSemFipeEndosso },
  data() {
    return {
      endossoRelatorio: [],
      veiculoSemValorFipe: [],
      paginaAtual: 1,
      itemPorPagina: 10,
      totalPaginas: 0,
      totalItens: 0,
      searchQuery: null,
      popupVeiculoSemFipe: false,
    };
  },
  watch: {
    async searchQuery() {
      await this.buscarEndosso(this.searchQuery);
    },
    async itemPorPagina() {
      await this.buscarEndosso();
    },
    async paginaAtual() {
      await this.buscarEndosso();
    },
  },
  computed: {
    endossoTituloTabela() {
      if (!this.endossoRelatorio.length) {
        return [];
      }

      const todosTitulos = new Set();
      let maiorCobertura = {};

      for (const item of this.endossoRelatorio) {
        const { cobertura = {}, ...rest } = item || {};

        Object.entries(rest).forEach(([tituloTabela, valor]) => {
          if (
            tituloTabela !== 'veiculoSemFipe' &&
            tituloTabela !== 'Cod Segurado' &&
            valor != null &&
            valor !== ''
          ) {
            todosTitulos.add(tituloTabela.toUpperCase());
          }
        });

        if (
          Object.keys(cobertura).length > Object.keys(maiorCobertura).length
        ) {
          maiorCobertura = cobertura;
        }
      }

      const todosTitulosCobertura = new Set(
        Object.keys(maiorCobertura)
          .filter(
            (titulo) =>
              maiorCobertura[titulo] !== null &&
              maiorCobertura[titulo] !== undefined &&
              maiorCobertura[titulo] !== '',
          )
          .map((titulo) => titulo.toUpperCase()),
      );

      return [...todosTitulos, ...todosTitulosCobertura];
    },
  },
  async mounted() {
    await this.buscarEndosso();
    await this.buscarVeiculoComError();
  },
  methods: {
    async buscarVeiculoComError() {
      const result = await service.endossoVeiculoSemFipe();
      if (result) {
        this.veiculoSemValorFipe = result;
      }
    },
    endossoVeiculoSemFipe() {
      this.popupVeiculoSemFipe = true;
    },
    closeModal() {
      this.popupVeiculoSemFipe = false;
    },
    async buscarEndosso(searchQuery = null) {
      const result = await service.buscarRelatorioEndosso(
        this.paginaAtual,
        this.itemPorPagina,
        searchQuery,
      );

      if (!result) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao buscar relatório',
          color: 'danger',
          position: 'top-center',
        });
        return;
      }

      this.totalPaginas = Math.ceil(result.count / this.itemPorPagina);

      this.totalItens = result.count;

      this.endossoRelatorio = result.rows;
    },
    coberturaValues(item) {
      return Object.values(item.cobertura);
    },
  },
};
</script>

<template>
  <div class="data-list-list-view" id="data-list-endosso-view">
    <vs-alert
      v-if="veiculoSemValorFipe.length"
      style="height: auto !important"
      class="my-3"
      active="true"
      color="danger"
    >
      O relatório contém veículos sem valor FIPE cadastrado
      <vs-button @click="endossoVeiculoSemFipe()">
        Ver veículos sem valor FIPE
      </vs-button>
    </vs-alert>
    <ModalVeiculoSemFipeEndosso
      :veiculoSemValorFipe="veiculoSemValorFipe"
      :popup-veiculo-sem-fipe-valor="popupVeiculoSemFipe"
      @closeModal="closeModal()"
    />

    <vs-table
      noDataText="Nenhum registro encontrado"
      class="tablePrincipal"
      ref="table"
      :max-items="itemPorPagina"
      :data="endossoRelatorio"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <vs-row class="flex items-center mb-4 mr-4">
          <vs-input
            class="border-none"
            name="search"
            id="search"
            v-model="searchQuery"
            placeholder="Placa ou Chassi"
            icon-pack="feather"
            icon="icon-search"
            icon-no-border
          />
        </vs-row>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemPorPagina - (itemPorPagina - 1) }} -
              {{
                endossoRelatorio.length - paginaAtual * itemPorPagina > 0
                  ? paginaAtual * itemPorPagina
                  : endossoRelatorio.length
              }}
              de {{ totalItens }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemPorPagina = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemPorPagina = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemPorPagina = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemPorPagina = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th
          v-for="(item, index) in endossoTituloTabela"
          :key="index"
          :sortKey="item"
        >
          <p>{{ item }}</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td>
              <p class="codigo-veiculo">{{ tr.Empresa }}</p>
            </vs-td>
            <vs-td>
              <p class="codigo-veiculo">{{ tr['Cod veiculo'] }}</p>
            </vs-td>
            <vs-td>
              <p class="cpf-cnpj">{{ tr['CPF/CNPJ'] }}</p>
            </vs-td>
            <vs-td>
              <p class="tipo-veiculo">{{ tr.tipoVeiculo }}</p>
            </vs-td>
            <vs-td>
              <p class="segurado">{{ tr.Segurado }}</p>
            </vs-td>
            <vs-td>
              <p class="placa">{{ tr.placa }}</p>
            </vs-td>
            <vs-td>
              <p class="chassi">{{ tr.chassi }}</p>
            </vs-td>

            <vs-td
              v-for="(itemCobertura, indexCobertura) in coberturaValues(tr)"
              :key="indexCobertura"
            >
              <p>{{ itemCobertura }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-card>
      <vs-pagination
        class="py-2"
        :total="totalPaginas"
        :max="7"
        v-model="paginaAtual"
      />
    </vs-card>
  </div>
</template>

<style scoped lang="scss">
#data-list-endosso-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        background: rgba(211, 209, 209, 0.219);
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
